<template>
  <div class="w-full h-full py-3">
    <div v-if="!isEditing" class="flex items-center h-full">
      <div class="table_data">
        <slot name="display">{{ displayValue }}</slot>
      </div>
    </div>

    <div v-else class="flex items-center w-full h-full px-2">
      <a-input
        v-if="inputType === 'text'"
        v-model:value="editValue"
        class="w-full"
        :placeholder="placeholder"
      />

      <a-select
        v-else-if="inputType === 'select'"
        v-model:value="editValue"
        class="w-full"
        :options="options"
        :placeholder="placeholder"
      />

      <a-input-number
        v-else-if="inputType === 'number'"
        v-model:value="editValue"
        class="w-full"
        :min="min"
        :max="max"
        :placeholder="placeholder"
      />

      <component
        v-else-if="customComponent"
        :is="customComponent"
        v-model:value="editValue"
        v-bind="customProps"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";

const props = defineProps({
  value: { type: [String, Number, Object], default: "" },
  isEditing: { type: Boolean, default: false },
  inputType: { type: String, default: "text" },
  options: { type: Array, default: () => [] },
  min: { type: Number, default: null },
  max: { type: Number, default: null },
  placeholder: { type: String, default: "Enter a value" },
  customComponent: { type: [Object, null], default: null },
  customProps: { type: Object, default: () => ({}) },
  formatter: { type: Function, default: (val) => val },
});

const emit = defineEmits(["update:value", "blur"]);

const editValue = ref(props.value);
const displayValue = computed(() => props.formatter(props.value));

watch(
  () => props.value,
  (newVal) => {
    editValue.value = newVal;
  }
);

watch(editValue, (newVal) => {
  emit("update:value", newVal);
});
</script>
